import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBillsFilters } from '../models/bills.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { and, comparison, eq, ge, le } from 'rsql-builder';

@Injectable({
  providedIn: 'root'
})
export class BillingApiService {

  constructor(private http: HttpClient) { }

  public getBillsList(filters: IBillsFilters): Observable<any> {
    const comps = [];
    let noFilter = true;
    if (filters.documentType) {
      comps.push(comparison('documentType', eq(filters.documentType)));
      noFilter = false;
    }
    if (filters.documentNumber) {
      const value = filters.documentNumber.replace(/\s/g, '%');
      comps.push(`numero==*${value}*`);
      noFilter = false;
    }
    if (filters.createdDateMin) {
      comps.push(comparison('createdDate', ge(filters.createdDateMin)));
      noFilter = false;
    }
    if (filters.createdDateMax) {
      comps.push(comparison('createdDate', le(filters.createdDateMax)));
      noFilter = false;
    }
    if (filters.operations) {
      comps.push(comparison('idOperacion', eq(filters.operations)));
      noFilter = false;
    }

    let params: HttpParams = new HttpParams();
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }
    if (filters.sortByDocumentNumber) {
      params = params.append('rsort', 'documentNumber').append('rdirection', filters.sortByDocumentNumber);
    }
    if (filters.sortByDocumentType) {
      params = params.append('rsort', 'tipoDocumento').append('rdirection', filters.sortByDocumentType);
    }
    if (filters.sortByCreatedDate) {
      params = params.append('rsort', 'createdDate').append('rdirection', filters.sortByCreatedDate);
    }

    if (filters.page || filters.page == 0) {
      params = params.append('page', filters.page.toString());
    }
    if (filters.size) {
      params = params.append('size', filters.size.toString());
    }
    return this.http.get(`${environment.apiBaseUrl}/core/portal/billing/getDocuments`, {params});
  }

  getBillDocument(id: number): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/core/portal/billing/download-link-factura/${id}`);
  }

  getReceiptDocument(id: number): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/core/portal/billing/download-link-recibo/${id}`);
  }
}
